"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheUpdateMatrix = void 0;
var _queryKeyHelpers = require("../ShopperCustomers/queryKeyHelpers");
var _queryKeyHelpers2 = require("./queryKeyHelpers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/** Parameters that get passed around, includes client config and possible parameters from other endpoints */

const updateOrderQuery = (customerId, {
  parameters
}) => ({
  update: [{
    queryKey: _queryKeyHelpers2.getOrder.queryKey(parameters)
  }]
});
const cacheUpdateMatrix = exports.cacheUpdateMatrix = {
  createOrder(customerId, {
    parameters
  }, response) {
    const {
      orderNo
    } = response;
    const update = !orderNo ? [] : [{
      queryKey: _queryKeyHelpers2.getOrder.queryKey(_objectSpread(_objectSpread({}, parameters), {}, {
        orderNo
      }))
    }];
    const invalidate = !customerId ? [] : [{
      queryKey: _queryKeyHelpers.getCustomerBaskets.queryKey(_objectSpread(_objectSpread({}, parameters), {}, {
        customerId
      }))
    }];
    return {
      update,
      invalidate
    };
  },
  createPaymentInstrumentForOrder: updateOrderQuery,
  updatePaymentInstrumentForOrder: updateOrderQuery,
  removePaymentInstrumentFromOrder: updateOrderQuery
};